import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
	FormControl,
	FormGroup,
	ControlLabel,
	HelpBlock,
} from 'react-bootstrap';

const flag = [
	{
		name: "重要",
		value: 'star',
		icon: 'star',
	},
	{
		name: "置頂",
		value: 'pin',
		icon: 'pin'
	},
	{
		name: "一般",
		value: 'normal',
		icon: 'newspaper'
	},
];

export class TextField extends React.Component {
	getHelpBlock() {
		let { showErrorMsg, fieldValue } = this.props;
		if (showErrorMsg) {
			return fieldValue === "" ? <HelpBlock>此欄位請勿空白</HelpBlock> : null;
		} else {
			return null;
		}
	}
	render() {
		let { fieldValue, fieldName } = this.props;
		return (
			<FormGroup>
				<FormControl
					type='text'
					value={fieldValue}
					onChange={event => this.props.onChangeHandler(fieldName, event)}>
				</FormControl>
				{this.getHelpBlock()}
			</FormGroup>
		);
	}
}

export class SelectField extends React.Component {
	getValue(fieldName) {
		let { selectedFlag, selectedNewsTypeId } = this.props;
		switch (fieldName) {
			case 'aNewsFlag':
				return selectedFlag;
			case 'aNewsType_id':
				return selectedNewsTypeId;
			default:
				return "";
		}
	}
	getSelector(fieldName) {
		const flagSelector = flag.map((item, index) => {
			return <option key={index} value={item.value} >{item.name}</option>
		})
		const newsTypeSelector = this.props.newsTypeArray.map((item, index) => {
			return <option key={index} value={item.id} >{item.name}</option>
		})
		switch (fieldName) {
			case 'aNewsFlag':
				return flagSelector;
			case 'aNewsType_id':
				return newsTypeSelector;
			default:
				break;
		}
	}
	render() {
		let { fieldName } = this.props;
		let value = this.getValue(fieldName);
		let selector = this.getSelector(fieldName);
		return (
			<FormGroup>
				<FormControl
					componentClass="select"
					value={value}
					onChange={event => this.props.onChangeHandler(fieldName, event)}>
					{selector}
				</FormControl>
				<FormControl.Feedback />
			</FormGroup>
		);
	}
}

export const DatePickerInstance = props => {
	return (
		<FormGroup>
			<ControlLabel>{props.type === "aNewsStart_time" ? "開始" : "結束"}</ControlLabel>
			<FormControl componentClass="div" readOnly={!props.enableEdit}>
				<DatePicker
					className="news-date-picker"
					dateFormat="YYYY/MM/DD"
					selected={props.type === "aNewsStart_time" ? moment(new Date(props.aNewsStart_time)) : moment(new Date(props.aNewsEnd_time))}
					onChange={date => props.onChangeDate(props.type, date)}
				/>
			</FormControl>
		</FormGroup>
	);
}

export class TextAreaField extends React.Component {
	getHelpBlock() {
		let { showErrorMsg, fieldValue } = this.props;

		if (showErrorMsg) {
			return fieldValue === "" ? <HelpBlock>此欄位請勿空白</HelpBlock> : null;
		} else {
			return null;
		}
	}
	render() {
		let { fieldValue, fieldName } = this.props;
		return (
			<FormGroup>
				<FormControl
					// readOnly={!enableEdit}
					rows={10}
					componentClass="textarea"
					value={fieldValue}
					onChange={event => this.props.onChangeHandler(fieldName, event)}>
				</FormControl>
				<FormControl.Feedback />
				{this.getHelpBlock()}
			</FormGroup>
		);
	}
}

export const ReadOnlyField = props => {
	return (
		<FormGroup>
			<FormControl
				readOnly={true}
				type='text'
				value={props.fieldValue}>
			</FormControl>
		</FormGroup>
	);
}


// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminComponents.jsx